import { LogrocketInitService } from '../services/logrocket-init/logrocket-init.service';

/**
 * @param {LogrocketInitService} logrocketInitService - Service that initializes LogRocket.
 * @returns {() => void} Bootstrap listener that syncs LogRocket for restored sessions.
 */
export function logrocketBootstrapFactory(logrocketInitService: LogrocketInitService): () => void {
  return (): void => {
    logrocketInitService.syncAuthenticatedSession();
  };
}
